import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useCustomerInitiativeList from './CiTemplateList.hook';
import GridList from 'modules/maya/components/GridList/GridList';
import MayaLayout from 'modules/maya/components/MayaLayout';
import { CustomerInitiativeListFilters } from 'modules/maya/routes/CustomerInitiativeList/CustomerInitiativeList.style';
import { useYodaCreateForm, YodaFormProvider } from 'services/yodaForm';
import ConfirmationDialog from 'yoda-ui/Dialogs/ConfirmationDialog';
import TextYoda from 'yoda-ui/Form/TextYoda';
import Loader from 'yoda-ui/Loader';
import { YodaColors } from 'yoda-ui/yodaTheme';

const CiTemplateList: FC = () => {
  const { providerFields } = useYodaCreateForm();
  const {
    customerInitiativeListColumnConfig,
    ciTitleFieldConfig,
    newElementButton,
    handleChangeCiTitle,
    cis,
    open,
    setOpen,
    deleteCiCallback,
    rowId,
    loading,
    onPageChange,
    onPageSizeChange,
    rowCountState,
    removeCiLoading,
  } = useCustomerInitiativeList();
  const { t } = useTranslation();
  const menuCiTemplateLabel = t('maya_main_menu_ci_tpl_label');

  return (
    <MayaLayout>
      <GridList
        getRowId={ (row) => row._id }
        loading={ loading }
        title={ menuCiTemplateLabel }
        columnConfig={ customerInitiativeListColumnConfig }
        rows={ cis }
        onPageChange={ onPageChange }
        onPageSizeChange={ onPageSizeChange }
        newElementButton={ newElementButton }
        rowCountState={ rowCountState }
        disableColumnMenu={ true }
        customFilters={
          (
            <YodaFormProvider { ...providerFields }>
              <Box sx={ CustomerInitiativeListFilters } >
                <TextYoda
                  onChange={ handleChangeCiTitle }
                  { ...ciTitleFieldConfig } />
              </Box>
            </YodaFormProvider>
          )
        }
      />
      {
        open && (
          <ConfirmationDialog
            dialogTitle={ t('maya_ci_modal_remove') }
            onConfirm={
              () => {
                deleteCiCallback(rowId);
              }
            }
            onConfirmLabel={ removeCiLoading ? <Loader center size={ 1 } color={ YodaColors.inherit } /> : t('actions_confirm_label') }
            onDismiss={ () => setOpen(false) }
            onDismissLabel={ t('actions_cancel_label') }
          >
          </ConfirmationDialog>
        )
      }
    </MayaLayout>
  );
};

export default CiTemplateList;
